module.exports = __webpack_public_path__ + "img/hero-desktop.5e7a8d21.png";